var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 7.49984V16.6665H14.1663V7.49984H15.833V17.4998C15.833 17.9601 15.4599 18.3332 14.9997 18.3332H4.99967C4.53944 18.3332 4.16634 17.9601 4.16634 17.4998V7.49984H5.83301ZM9.16634 7.49984V14.9998H7.49967V7.49984H9.16634ZM12.4997 7.49984V14.9998H10.833V7.49984H12.4997ZM12.4997 1.6665C12.8584 1.6665 13.1768 1.89603 13.2902 2.23631L13.933 4.16567L16.6663 4.1665V5.83317H3.33301V4.1665L6.06551 4.16567L6.7091 2.23631C6.82253 1.89603 7.14098 1.6665 7.49967 1.6665H12.4997ZM11.899 3.33317H8.10031L7.82217 4.16567H12.1763L11.899 3.33317Z",
    fill: "white"
  }))));
};
export { SvgDelete as ReactComponent };
export default __webpack_public_path__ + "assets/43187ed3.svg";